import Seo from "@/components/Seo";
import { Reveal } from "@/components/Motion";
import { CtaBanner, PageHero } from "@/components/Sections";

const PLACEHOLDERS = [
  { image: "/images/facade.jpg", label: "Facade & nybyggeri" },
  { image: "/images/office.jpg", label: "Kontor & erhvervslokaler" },
  { image: "/images/warehouse.jpg", label: "Lager & erhvervsejendom" },
  { image: "/images/renovation.jpg", label: "Renovering" },
  { image: "/images/construction.jpg", label: "Byggeprojekt" },
  { image: "/images/corridor.jpg", label: "Fællesarealer" },
];

const Projects = () => (
  <>
    <Seo
      title="Projekter — Malerarbejde for erhverv | Al Maler Mester ApS"
      description="Se udvalgte malerprojekter for erhvervskunder. Projektdokumentation med billeder, lokation og opgavetype er under opbygning."
    />
    <PageHero
      overline="Projekter"
      title={
        <>
          Udvalgte{" "}
          <span className="font-editorial italic font-medium text-signal">projekter</span>
        </>
      }
      lead="Vi er i gang med at dokumentere vores opgaver med projektbilleder, lokation, opgavetype og før/efter-dokumentation. Felterne nedenfor er markerede placereholdere, indtil de første cases er klar."
    />
    <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24 md:pb-36">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {PLACEHOLDERS.map((p, i) => (
          <Reveal key={p.image} delay={(i % 3) * 0.08}>
            <div data-testid={`project-placeholder-${i}`} className="group grain overflow-hidden relative">
              <img
                src={p.image}
                alt={`${p.label} — projektdokumentation på vej`}
                loading="lazy"
                className="w-full h-[320px] object-cover grayscale group-hover:grayscale-0 group-hover:scale-[1.03] transition-[filter,transform] duration-700"
              />
              <div className="absolute inset-0 bg-ink/40 group-hover:bg-ink/10 transition-colors duration-700" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="bg-bone/90 backdrop-blur-xl px-4 py-3">
                  <p className="text-[10px] uppercase tracking-[0.2em] font-semibold text-signal">Placeholder</p>
                  <p className="font-cabinet font-bold text-sm mt-1">{p.label}</p>
                  <p className="text-xs text-soot mt-0.5">Projektdokumentation på vej</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-12 text-sm text-soot max-w-2xl leading-relaxed">
          Af hensyn til vores kunders fortrolighed publicerer vi kun projekter med kundens accept. Kontakt os
          gerne for en dialog om erfaring inden for netop jeres type opgave.
        </p>
      </Reveal>
    </section>
    <CtaBanner />
  </>
);

export default Projects;
